import React, {useState, useEffect, useContext} from 'react';
import {loadModules} from 'esri-loader';
import Button, { ButtonGroup } from 'calcite-react/Button';
import MeasureLineIcon from 'calcite-ui-icons-react/MeasureLineIcon';
import MeasureAreaIcon from 'calcite-ui-icons-react/MeasureAreaIcon';
import TrashIcon from 'calcite-ui-icons-react/TrashIcon';
import Mapstore from '../MapStore';

const Measure = ({view, setSelectMeasure}) => {
    const nodeRef = React.createRef(); //
    const [selected, setSelected] = useState(0);
    const store = useContext(Mapstore);

    //let measurement;
    
    useEffect(() => {
        const runEffect = async () => {
            loadModules(['esri/widgets/Measurement'], {css: true}).then(([Measurement]) => {
                const measurement = new Measurement({
                    view: view,
                    areaUnit: 'square-us-feet',
                    linearUnit: 'us-feet',
                    container: document.getElementById('info')
                });
                setSelectMeasure(measurement);
            }).catch((err) => console.error(err));  
        }
        runEffect();
        return () => {
            if (!!store.measurement) {
                console.log('closed');
                store.measurement.container = null;
            }
        }
    }, [nodeRef.current]);

    useEffect(() => {
        if (store.measurement) {
            if (selected === 1) {
                store.measurement.activeTool = 'distance';
            } else if (selected === 2) {
                store.measurement.activeTool = 'area';
            } else {
                store.measurement.clear();
            }
        }
    }, [selected]);

    return (
        <React.Fragment>
            <div id='measurement' ref={nodeRef}>
                <ButtonGroup>
                    <Button key={1} onClick={() => setSelected(1)} small clear={selected !== 1} icon={<MeasureLineIcon size={16} />} iconPosition="before">Line</Button>
                    <Button key={2} onClick={() => setSelected(2)} small clear={selected !== 2} icon={<MeasureAreaIcon size={16} />} iconPosition="before">Area</Button>
                    <Button key={3} onClick={() => setSelected(0)} small clear icon={<TrashIcon size={16} />} iconPosition="before">Clear</Button>
                </ButtonGroup>
            </div>
            <div id='info'></div>
        </React.Fragment>
    )  
}

export { Measure };